<template>
  <div class="boxs" :height="windowHeight">
    <iframe id="mapPage" width="100%" :height="windowHeight" frameborder=0
      src="https://apis.map.qq.com/tools/locpicker?search=1&type=1&key=RSEBZ-Z35HS-4F4O3-6GT5A-XQB4H-TOBFA&referer=myapp">
    </iframe>
  </div>
</template>

<script>
export default {
  props: {
    windowHeight: ""
  },
  data () {
    return {
    }
  },
  created () {
    const taht = this
    window.addEventListener('message', function (event) {
      // 接收位置信息，用户选择确认位置点后选点组件会触发该事件，回传用户的位置信息
      var loc = event.data
      if (loc && loc.module === 'locationPicker') {
        taht.$emit('success', loc)
      }
    }, false)
  },
  methods: {
  }
}
</script>
<style lang="less" scoped>

  @import "~@/assets/css/var.less";

  .boxs{
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 999;
  }

</style>
